module.exports = __webpack_public_path__ + "img/Small-2-Bevel-Attachment-18.caf564d3.png";